// @flow
import * as React from 'react';
import { Modal } from 'react-bootstrap';
import Video from './Video';

type Props = {
  showModal: boolean,
  videoUrl: string,
  title: string,
  close: () => void
};

const VideoModal = ({ showModal, close, videoUrl, title }: Props) => (
  <Modal show={showModal} onHide={close}>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Video src={videoUrl} title={title} />
    </Modal.Body>
  </Modal>
);

export default VideoModal;



// WEBPACK FOOTER //
// ./src/components/VideoModal.js